module.exports = __webpack_public_path__ + "static/mrrooter-sc-cf0d94824b95e0a716389ac0cc03e5f9.png";